exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-to-ceiling[data-v-37ea573c] {\n    position: fixed;\n    display: inline-block;\n    text-align: center;\n    cursor: pointer;\n}\n.back-to-ceiling[data-v-37ea573c]:hover {\n    background: #d5dbe7;\n}\n.fade-enter-active[data-v-37ea573c],\n.fade-leave-active[data-v-37ea573c] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-37ea573c],\n.fade-leave-to[data-v-37ea573c] {\n    opacity: 0\n}\n.back-to-ceiling .Icon[data-v-37ea573c] {\n    fill: #9aaabf;\n    background: none;\n}\n\n", ""]);

// exports
